import myRouter from './MyRouterResolver'
import PackageList from 'src/pages/package/Index'
import PackageDetail from 'src/pages/package/Detail'
import PackageSearch from 'src/pages/package/Search'

let router = myRouter()
router.addComponent('list', PackageList, {
  modules: ['infinite-scroll', 'preloader', 'notification', 'gauge', 'swiper', 'tabs', 'searchbar']
})
router.addComponent('detail/:id', PackageDetail, {
  modules: ['grid', 'notification', 'swiper', 'typography']
})
router.addComponent('search', PackageSearch, {
  modules: ['searchbar']
})
export default router
